import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import {
  HttpClientContext,
  HttpProjectSetupContext,
  HttpUserAdminContext,
  HttpProjectAdminContext,
  HttpDprContext,
  HttpSharedContext,
  HttpSharedFileContext,
  HttpSharedCoreContext,
  HttpDprDetailsContext,
  HttpReportContext,
} from '@shared/enums';
import { ReqType } from '@shared/utils';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  private baseUrl = `${environment.dprApi.endpoint}`;
  private coreUrl = `${environment.coreApi.endpoint}`;
  private fileUrl = `${environment.filesApi.endpoint}`;

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const httpContexts = [
      ...Object.values(HttpClientContext),
      ...Object.values(HttpProjectSetupContext),
      ...Object.values(HttpUserAdminContext),
      ...Object.values(HttpProjectAdminContext),
      ...Object.values(HttpDprContext),
      ...Object.values(HttpSharedContext),
      ...Object.values(HttpSharedFileContext),
      ...Object.values(HttpSharedCoreContext),
      ...Object.values(HttpDprDetailsContext),
      ...Object.values(HttpReportContext),
    ];

    const reqType = request.context.get(ReqType);

    if (httpContexts.find((x) => x === reqType)) {
      const apiRequest = request.clone({
        url: `${this.getBaseUrl(reqType)}${request.url}`,
      });

      return next.handle(apiRequest);
    }

    return next.handle(request);
  }

  private getBaseUrl(reqType: string): string {
    if (Object.values(HttpSharedFileContext).includes(reqType)) {
      return this.fileUrl;
    }
    if (Object.values(HttpSharedCoreContext).includes(reqType)) {
      return this.coreUrl;
    }

    return this.baseUrl;
  }
}
